import { render } from "./item1000.vue?vue&type=template&id=2662085f&scoped=true"
import script from "./item1000.vue?vue&type=script&lang=js"
export * from "./item1000.vue?vue&type=script&lang=js"

import "./item1000.vue?vue&type=style&index=0&id=2662085f&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2662085f"]])

export default __exports__